const Footer = () => {
    return (
        <footer className='flex min-h-10 w-full shrink-0 items-center justify-center border-t border-slate-800 bg-slate-950 px-4 py-2 text-center text-xs'>
            <p className='text-slate-400'>© {new Date().getFullYear()} Namlı Holding. Tüm hakları saklıdır.</p>
        </footer>
    );
};

export default Footer;
